export default "__VITE_ASSET___MwguQgU__"